import React, { useRef, useState, useMemo, useEffect } from "react"
import TabsCustom from "src/components/TabsCustom"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import { ToolBarStyle } from "../../../HumanResource/Work/Task/styled"
import ModalCreateData from "./Modal/ModalCreateData"
import ListDataRequest from "./components/ListDataRequest"
import WarehouseService from "src/services/WarehouseService"
import { message } from "antd"
import STORAGE, { getStorage } from "src/lib/storage"

const DataRequest = () => {
  const [disableBtn, setDisableBtn] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activeKey, setActiveKey] = useState("all")
  const [refresh, setRefresh] = useState(false)
  const [filter, setFilter] = useState({})
  const [shownError, setShownError] = useState(false)
  const [tabStatus, setTabStatus] = useState("0")
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const Tabs = {
    all: {
      type: "",
      name: "Tất cả",
      status: "",
    },
    pending: {
      type: "0",
      name: "Chờ duyệt",
      status: "0",
    },
    success: {
      type: "1",
      name: "Đã duyệt",
      status: "1",
    },
    reject: {
      type: "2",
      name: "Từ chối",
      status: "2",
    },
  }
  const items = Object.keys(Tabs).map(key => ({
    key,
    label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  }))
  const handleChangeTab = key => {
    setActiveKey(key)
    setTabStatus(Tabs[key].status)
  }

  const handleExportExcel = async () => {
    try {
      const response = await WarehouseService.exportWareHouseAppovalData({
        // type : "0",
        supplier_id: filter.supplier_id ?? null,
        network_id: filter.network_id ?? null,
        type: Tabs[activeKey]?.type,
      })

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "Danh_sach_phieu_de_xuat_nhap_kho.xlsx")

        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }

  const hasPermission = permissions.includes("warehouse.data")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }

  return (
    <div>
      <WrapperStyle>
        <ToolBarStyle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 4,
              marginBottom: 20,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#005F90",
                margin: 0,
              }}
            >
              DANH SÁCH PHIẾU NHẬP KHO
            </h3>
          </div>
          <div className="right-side">
            {permissions.includes("warehouse.data.create") ? (
              <Button
                btnType="primary1"
                onClick={() => setIsModalOpen(true)}
                size="small"
                disabled={disableBtn}
              >
                Tạo phiếu nhập kho
              </Button>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.data.export") ? (
              <Button btnType="primary1" onClick={handleExportExcel}>
                Xuất Excel
              </Button>
            ) : (
              <React.Fragment />
            )}
          </div>
          {/* <div className="right-side">
                      <Button btnType="primary1" onClick={handleExportExcel}>
                        Xuất Excel
                      </Button>
                    </div> */}
          <div style={{ width: "100%", overflowX: "auto" }}>
            <StyleTabsCustom>
              <TabsCustom
                onChange={handleChangeTab}
                activeKey={activeKey}
                items={items}
                defaultActiveKey="all"
                type="card"
              />
            </StyleTabsCustom>
            <ListDataRequest
              refresh={refresh}
              setRefresh={setRefresh}
              type={Tabs[activeKey].type}
              status={Tabs[activeKey].status}
              setFilter={setFilter}
              filter={filter}
              // scroll={{ x: true }}
            />
          </div>
        </ToolBarStyle>
      </WrapperStyle>

      {isModalOpen && (
        <ModalCreateData
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onOk={() => {
            setIsModalOpen(false)
            setRefresh(prev => !prev) // Phải khác giá trị cũ!
          }}
        />
      )}
    </div>
  )
}

export default DataRequest
